var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showBack
        ? _c(
            "div",
            { staticClass: "robot-header fx" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    icon: "el-icon-arrow-left",
                    type: "text",
                    size: "mini",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.dispatch("robot", "activeIndexChange", 0)
                    },
                  },
                },
                [_vm._v("返回")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.companyList.length
        ? _c(
            "h5",
            {
              staticStyle: {
                color: "#333333",
                "font-size": "16px",
                "font-weight": "bold",
              },
            },
            [_vm._v("小T猜你可能对以下企业感兴趣")]
          )
        : _vm._e(),
      _vm.companyLoading
        ? _c(
            "h5",
            {
              staticStyle: {
                color: "#333333",
                "font-size": "16px",
                "font-weight": "bold",
              },
            },
            [_vm._v("小T正在努力查找中...")]
          )
        : _vm._e(),
      _vm.companyLoading
        ? _c("div", { staticClass: "loadingBox" }, [
            _c("i", {
              staticClass: "el-icon-loading",
              staticStyle: { "font-size": "24px", color: "#5088ff" },
            }),
          ])
        : _vm._e(),
      _c(
        "ul",
        { staticClass: "someCompany" },
        _vm._l(_vm.companyList, function (company) {
          return _c("li", { key: company.id }, [
            _c(
              "p",
              {
                staticClass: "companyName",
                on: {
                  click: function ($event) {
                    return _vm.preShowDrawer(company)
                  },
                },
              },
              [_vm._v(_vm._s(company.name))]
            ),
            _c(
              "p",
              { staticClass: "tips", attrs: { title: company.similarValue } },
              [_vm._v(_vm._s(company.similarValue))]
            ),
          ])
        }),
        0
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.companyList.length,
              expression: "!companyList.length",
            },
          ],
          staticClass: "empty",
        },
        [_vm._m(0)]
      ),
      _c(
        "div",
        { class: ["btns", { btnsHidden: !_vm.companyList.length }] },
        [
          _c(
            "el-button",
            {
              attrs: { type: "default-black", w100: "" },
              on: { click: _vm.batchStarFn },
            },
            [_vm._v("全部收藏")]
          ),
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "20px" },
              attrs: { type: "dialog-confirm", w100: "" },
              on: { click: _vm.toPage },
            },
            [_vm._v("查看更多")]
          ),
        ],
        1
      ),
      _c("view-number", {
        key: _vm.drawerKey,
        ref: "vNumber",
        attrs: {
          baseData: _vm.numberData,
          companyStatus: _vm.companyStatus,
          waiting: _vm.loading,
        },
        on: { refreshList: _vm.contactList, lookNumber: _vm.lookNumberInner },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty-ordinary" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/newicons/i002.png"),
          alt: "",
          srcset: "",
        },
      }),
      _c("p", { staticClass: "center" }, [_vm._v("暂无数据")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }